import React, { useState } from 'react';
import { Spin, Button, message } from 'antd';
import { providerOverrideDelete } from 'api/calendarSetting';
import { TimeItemType } from 'types/appointmentSetting';
import AddOverrideModal from './components/AddOverrideModal';
import useOverride from 'hooks/useOverride';
import trashIcon from 'assets/common/trash.svg';
import pencilIcon from 'assets/common/grayPencil.svg';
import type { IProviderOverrideListWithDates } from './components/AddOverrideModal/types';
import { getOverrideDate, transferTimePicker, mergeOverrideList } from './utils';
import s from './s.module.less';

const DatesOverride = () => {
    const [openAddAppointmentModal, setOpenAddAppointmentModal] = useState(false);
    const [overrideList, loading, fetchData] = useOverride();
    const [editItem, setEditItem] = useState<IProviderOverrideListWithDates | null>(null);

    const mergedOverrideList = mergeOverrideList(overrideList);

    const onCancel = () => {
        setOpenAddAppointmentModal(false);
        setEditItem(null);
    };

    const deleteBlockoutDatesItem = async (item: IProviderOverrideListWithDates) => {
        try {
            const { data } = await providerOverrideDelete(item.overrideDates.map(({ id }) => id));
            if (data.code === 200) {
                message.success(data.message);
                fetchData();
            }
        } catch (error) {
            console.error(error);
        }
    };

    const editDatesItem = (item: IProviderOverrideListWithDates) => {
        setOpenAddAppointmentModal(true);
        setEditItem(item);
    };

    return (
        <Spin spinning={loading}>
            <div className={s.overrideContainer}>
                {
                    mergedOverrideList && mergedOverrideList.map((item, index) => {
                        const timeArr = item?.time;
                        return (
                            <div className={s.overrideCard} key={index}>
                                <div className={s.dateColumn}>
                                    {
                                        typeof getOverrideDate(item) === 'string' ? <span className={s.dateText}>{getOverrideDate(item)}</span> : (getOverrideDate(item) as string[]).map((date) => {
                                            return <span className={s.dateText} key={date}>{date}</span>;
                                        })
                                    }
                                </div>
                                <div className={s.timeColumn}>
                                    {
                                        timeArr && timeArr?.map((i: TimeItemType, idx: number) => {
                                            return <span className={s.timeText} key={idx}>{transferTimePicker(i)}</span>;
                                        })
                                    }
                                </div>
                                <div className={s.actionContainer}>
                                    <img className={s.icon} onClick={() => editDatesItem(item)} src={pencilIcon} />
                                    <img className={`${s.icon} ${s.iconSpacing}`} onClick={() => deleteBlockoutDatesItem(item)} src={trashIcon} />
                                </div>
                            </div>
                        );
                    })
                }
            </div>
            <Button
                onClick={() => {
                    setOpenAddAppointmentModal(true);
                }}
            >+ Add an override
            </Button>
            {
                openAddAppointmentModal && <AddOverrideModal onCancel={onCancel} onFetchData={fetchData} editItem={editItem} />
            }
        </Spin>
    );
};

export default DatesOverride;
